import { env } from './.env';

export const environment = {
  production: false,
  // Grouping common
  version: env['npm_package_version'] + '-dev',
  defaultLanguage: 'de-DE',
  supportedLanguages: ['de-DE', 'en-US', 'es-ES', 'fr-FR', 'it-IT'],
  // Grouping API
  apiUrl: 'https://val-dev-api.vinova.sg',
  apiVersion: 'val-bff',
  downloadTemplateS3:
    'https://jp-val-public-uploads-dev.s3.ap-southeast-1.amazonaws.com/Monthly+Roster+Template.xlsx',
  logger: true, // Enable logging in development
  enableNetworkStatusIndicator: true, // Enable network status indicator
  enableSSOCallback: false, // Enable SSO callback
  redirectToLoginJPom:
    'http://jpomuat2/jpom/api/authenendpoint/1.0.0/oauth2/authorize?' +
    'response_type=id_token%20token&client_id=OvlFwEMF0XOfKzSYPM3YcHbGS2Ia&' +
    'state=ZjJEVjFiU3NXWnJCMmNzQ29VRXJKM3F6N1NwcjI3UXlZYW1DZE9kcnhoVjRy&' +
    'redirect_uri=https%3A%2F%2Fval-dev.vinova.sg&scope=openid&' +
    'nonce=ZjJEVjFiU3NXWnJCMmNzQ29VRXJKM3F6N1NwcjI3UXlZYW1DZE9kcnhoVjRy', // Redirect to login JPOM
  countdownToRedirect: 3,
};
